// extracted by mini-css-extract-plugin
export var button = "styles-module--button--OrB19";
export var caret = "styles-module--caret--CqNTY";
export var caretopened = "styles-module--caretopened--m6jq6";
export var container = "styles-module--container--RFTdi";
export var copyhome = "styles-module--copyhome--MPR+e";
export var copyxponent = "styles-module--copyxponent--DFocn";
export var open = "styles-module--open--K4mMz";
export var productbuttoncontainer = "styles-module--productbuttoncontainer--dHOiG";
export var productbuttontext = "styles-module--productbuttontext--etwNZ";
export var productcontainer = "styles-module--productcontainer--LQ5QF";
export var productcopy = "styles-module--productcopy--Uco8m";
export var productopened = "styles-module--productopened--wexyf";